"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var FilterList_1 = __importDefault(require("@material-ui/icons/FilterList"));
var styles_1 = require("@material-ui/core/styles");
var index_1 = require("../../../../index");
var props_1 = require("../../../context/props");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var spacing = _a.spacing;
    return ({
        buttonRoot: {
            minWidth: 0,
            marginRight: spacing(),
            paddingLeft: spacing(),
            paddingRight: spacing()
        },
        buttonStartIcon: {
            marginRight: 0,
            marginLeft: 0
        }
    });
});
var FilterButton = function (props) {
    var onClick = props.onClick;
    var _a = (0, props_1.usePropsContext)(), isMobileHeader = _a.isMobileHeader, translate = _a.translate;
    var classes = useStyles();
    var text = (0, react_1.useMemo)(function () { return (isMobileHeader ? '' : translate('filter', 'Filter')); }, [isMobileHeader, translate]);
    return (react_1.default.createElement(index_1.Button, { onClick: onClick, variant: "contained", color: "primary", startIcon: react_1.default.createElement(FilterList_1.default, null), classes: {
            root: classes.buttonRoot,
            startIcon: classes.buttonStartIcon
        } }, text));
};
exports.default = FilterButton;
